<template>
  <base-sticky :margin="header.sticky.margin" name="headerPLP">
    <div
      v-style:top="{ sm: '0', lg: '4.5rem' }"
      class="body-5 mx-6 pb-3 pt-2 b-t b-grey-80 bg-white flex sticky between z-below-header <lg:hidden"
      :class="{ 'bg-op-80': overlayTitle }"
    >
      <div aria-live="polite">
        <p>
          {{ total }} {{ $pluralize($t.products, total) }}
        </p>
      </div>
      <div class="flex items-center <lg:row-span-2">
        <!-- Desktop sort/filter button -->
        <base-button
          aria-controls="plp-filters"
          :aria-expanded="filtersShown"
          class="flex gap-1 items-center <lg:hidden"
          @click="onFiltersToggle"
        >
          <span class="<lg:sr-only">
            {{ totalFiltersApplied ? `${$t.showFilters} (${totalFiltersApplied})` : $t.showFilters }}
          </span>
          <vf-icon name="filters" size="sm" />
        </base-button>
      </div>
    </div>
    <panel-filters v-slot="attrs">
      <slot v-bind="attrs" />
    </panel-filters>
  </base-sticky>

  <!-- Mobile sort/filter button -->
  <div class="my-6 flex w-full center bottom-0 fixed z-header lg:hidden">
    <base-button
      aria-controls="plp-filters"
      :aria-expanded="filtersShown"
      class="subtitle-5 c-brand-5 px-6 py-3 rounded bg-brand-4 flex shadow-lg transform transition-transform duration-300 ease-in-out items-center bottom-0 left-1/2 fixed z-50 -translate-x-1/2"
      :class="{
        'translate-y-0 mb-4': !isScrolling,
        'translate-y-full': isScrolling,
      }"
      @click="onFiltersToggle"
    >
      <span>
        {{ totalFiltersApplied ? `${$t.showFilters} (${totalFiltersApplied})` : $t.showFilters }}
      </span>
      <vf-icon class="ml-1" name="filters" size="md" />
    </base-button>
  </div>
</template>

<script lang="ts" setup>
import type { Catalog, Search } from '#root/api/clients/product/data-contracts'
import type { FiltersMap } from '#types/filters'

const props = defineProps<{
  list: Catalog | Search | null
  productsLoading: boolean
  nextPageLoading: boolean
  sideFilters: boolean
  pickupFilters: boolean
  title?: string
  filters: FiltersMap
  filtersQuery: Record<string, string[]>
  sortOptions: { label: string, value: string }[]
  sortState: string
  storeFilterState?: string
  overlayTitle?: boolean
}>()

const { $t } = useNuxtApp()
const filtersQuery = useRouteQuery('filters')
const header = useHeaderStore()

const filtersShown = defineModel('filtersShown')
const PanelFilters = createPanel('filters')

const total = computed(() => props.list?.total || 0)
const countAppliedFilters = (query: any): number | null => {
  const filters = typeof query === 'string' ? JSON.parse(query || '{}') : query || {}
  const count = Object.values(filters).reduce((sum: number, arr) => sum + (Array.isArray(arr) ? arr.length : 0), 0)
  return count > 0 ? count : null
}
const totalFiltersApplied = computed(() => countAppliedFilters(filtersQuery.value))

const onFiltersToggle = () => PanelFilters.open()

const { isScrolling } = useScroll(window, { throttle: 150, idle: 150 })
</script>
